<template>
  <v-row align="start" justify="center">
    <v-col cols="12">
      <v-toolbar flat>
        <v-icon large class="mr-3">insert_chart_outlined</v-icon>
        <v-toolbar-title>Strategy</v-toolbar-title>
        <v-tooltip right color="transparent">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon v-on="on">
              <v-icon color="primary">mdi-information</v-icon>
            </v-btn>
          </template>
          <v-card width="300">
            <v-card-title>Strategy</v-card-title>
            <v-card-text>
              Strategy is as a template for your commands. You can config default variables which can enable to always to overwrite or just overwrite if missing.
              Strategy help you to save time for repeated parameters like: maxPos (maximum position per instrument), maxRisk (max risk per trade), ..
            </v-card-text>
          </v-card>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-btn outlined color="primary" @click="onCreate">Create Strategy</v-btn>
      </v-toolbar>
    </v-col>
    <v-col v-if="newItem" cols="12">
      <CRUD :new-item="newItem" @closed="onClosed"></CRUD>
    </v-col>
    <v-col v-else-if="strategies" cols="12">
      <v-data-iterator
        :items="Object.values(strategies)"
        :items-per-page.sync="itemsPerPage"
        :footer-props="{ itemsPerPageOptions }"
      >
        <template v-slot:default="props">
          <v-row align="start" justify="center">
            <v-col v-for="item in props.items" :key="item.id" cols="12">
              <Card :item="item"></Card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { STRATEGY, SCHEMA } from "@/store/actions.type";
import Card from "@/components/strategies/Card.vue";
import CRUD from "@/components/strategies/CRUD.vue";

export default {
  name: "Strategies",
  components: {
    Card,
    CRUD
  },
  data() {
    return {
      itemsPerPageOptions: [4, 8, 12],
      itemsPerPage: 4,
      newItem: null
    };
  },

  computed: {
    ...mapGetters(["strategies", "currentUser"])
  },
  watch: {
    currentUser() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (!this.strategies && this.currentUser) {
        this.$store.dispatch(STRATEGY.FETCH, this.currentUser.id);
      }
    },
    onClosed() {
      this.newItem = null;
    },
    onCreate() {
      this.$store.dispatch(SCHEMA.GET, "strategy").then(result => {
        this.newItem = result.data;
      });
    }
  }
};
</script>
<style></style>
